import config from "react-global-configuration";

config.set(
    {
    base:"https://portal.bngrenew.com/api/",
    appConfig : 'appConfig' ,
    checkSub:  'checkSub',
    unsub: 'unsubscribe',
    callInfo:'callInfo',
    subscribe:'subscribe',
    elasticPublish:"https://serviceusagesv1.bngrenew.com/publish",
    // heUrl:"http://he.ibadat360.com/mvmtngc/index_test.php",  //localhost
    heUrl:"http://he.ibadat360.com/mvmtngc/index.php", //live
    promotionalUrl:"https://camp-report.bngrenew.com/mv_mtn_gc.php",
    headers: {
        'Username': 'web',
        "Servicefor":"mtngc",
        "Serviceid":"mtngc",
        "sid":localStorage.getItem("sessionId") || "NA"
    }
});
export const getHeaders = () => {
    const headers = { ...config.get("headers") };  
    headers["w_req_url"] = window.location.href;
    headers["sid"]= localStorage.getItem("sessionId") || "NA";
    return headers;  
};

export default config